// Yolcular, gruplar, Excel içe aktarma (C21–C25): Control yönlendirmeleri (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const PassengerList = load(() => import('./PassengerList'), 'PassengerList');
const PassengerDetail = load(() => import('./PassengerDetail'), 'PassengerDetail');
const PassengerForm = load(() => import('./PassengerForm'), 'PassengerForm');
const ImportWizard = load(() => import('./ImportWizard'), 'ImportWizard');
const Groups = load(() => import('./Groups'), 'Groups');

export const rosterRoutes = (
  <>
    <Route path="yolcular" element={guard(PassengerList, 'passengers')} />
    <Route path="yolcular/yeni" element={guard(PassengerForm, 'passengers', { action: 'edit' })} />
    <Route path="yolcular/ice-aktar" element={guard(ImportWizard, 'passengers', { action: 'edit' })} />
    <Route path="yolcular/gruplar" element={guard(Groups, 'passengers')} />
    <Route path="yolcular/:id" element={guard(PassengerDetail, 'passengers')} />
    <Route path="yolcular/:id/duzenle" element={guard(PassengerForm, 'passengers', { action: 'edit' })} />
  </>
);
